/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

// Navigation for SUPER_ADMIN users (global access)
export const superAdminNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard Global',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    },
    {
        id: 'catalogs',
        title: 'Catalogos',
        type: 'collapsable',
        icon: 'heroicons_outline:folder',
        children: [
            {
                id: 'basket-types',
                title: 'Tipos de Cestas',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/catalogs/basket-types'
            },
            {
                id: 'locations',
                title: 'Ubicaciones',
                type: 'basic',
                icon: 'heroicons_outline:map-pin',
                link: '/catalogs/locations'
            },
            {
                id: 'vehicles',
                title: 'Vehiculos',
                type: 'basic',
                icon: 'heroicons_outline:truck',
                link: '/catalogs/vehicles'
            },
            {
                id: 'stores',
                title: 'Tiendas',
                type: 'basic',
                icon: 'heroicons_outline:building-storefront',
                link: '/catalogs/stores'
            },
            {
                id: 'forklifts',
                title: 'Montacargas',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/catalogs/forklifts'
            },
            {
                id: 'forklift-operators',
                title: 'Operadores de Montacargas',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/catalogs/forklift-operators'
            },
            {
                id: 'pallet-jacks',
                title: 'Transpaletas',
                type: 'basic',
                icon: 'heroicons_outline:arrows-right-left',
                link: '/catalogs/pallet-jacks'
            },
            {
                id: 'repair-events',
                title: 'Reparaciones',
                type: 'basic',
                icon: 'heroicons_outline:wrench-screwdriver',
                link: '/catalogs/repair-events'
            },
            {
                id: 'repair-companies',
                title: 'Empresas de Reparacion',
                type: 'basic',
                icon: 'heroicons_outline:building-office',
                link: '/catalogs/repair-companies'
            }
        ]
    },
    {
        id: 'operations',
        title: 'Operaciones',
        type: 'collapsable',
        icon: 'heroicons_outline:arrows-right-left',
        children: [
            {
                id: 'movements',
                title: 'Movimientos',
                type: 'basic',
                icon: 'heroicons_outline:arrow-path',
                link: '/operations/movements'
            },
            {
                id: 'initial-stock',
                title: 'Carga Inicial',
                type: 'basic',
                icon: 'heroicons_outline:inbox-arrow-down',
                link: '/operations/initial-stock'
            },
            {
                id: 'inventory-count',
                title: 'Conteo Fisico',
                type: 'basic',
                icon: 'heroicons_outline:calculator',
                link: '/operations/inventory-count'
            },
            {
                id: 'trip-log',
                title: 'Registro de Viaje',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/operations/trip-log'
            },
            {
                id: 'routes',
                title: 'Rutas',
                type: 'basic',
                icon: 'heroicons_outline:map',
                link: '/operations/routes'
            }
        ]
    },
    {
        id: 'inventory',
        title: 'Inventario',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'balances',
                title: 'Saldos',
                type: 'basic',
                icon: 'heroicons_outline:scale',
                link: '/inventory/balances'
            },
            {
                id: 'snapshots',
                title: 'Historico',
                type: 'basic',
                icon: 'heroicons_outline:clock',
                link: '/inventory/snapshots'
            }
        ]
    },
    {
        id: 'incidents',
        title: 'Incidencias',
        type: 'collapsable',
        icon: 'heroicons_outline:exclamation-triangle',
        children: [
            {
                id: 'incidents-list',
                title: 'Incidencias',
                type: 'basic',
                icon: 'heroicons_outline:flag',
                link: '/incidents'
            },
            {
                id: 'damaged',
                title: 'Cestas Danadas',
                type: 'basic',
                icon: 'heroicons_outline:x-circle',
                link: '/incidents/damaged'
            },
            {
                id: 'recycling',
                title: 'Reciclaje',
                type: 'basic',
                icon: 'heroicons_outline:arrow-path-rounded-square',
                link: '/incidents/recycling'
            },
            {
                id: 'police-assistance',
                title: 'Apoyo Policial',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/incidents/police-assistance'
            },
            {
                id: 'road-assistance',
                title: 'Auxilio Vial',
                type: 'basic',
                icon: 'heroicons_outline:truck',
                link: '/incidents/road-assistance'
            }
        ]
    },
    {
        id: 'settings',
        title: 'Configuracion',
        type: 'collapsable',
        icon: 'heroicons_outline:cog-6-tooth',
        children: [
            {
                id: 'users',
                title: 'Usuarios',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/settings/users'
            },
            {
                id: 'roles',
                title: 'Roles',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/settings/roles'
            },
            {
                id: 'expected-inventory',
                title: 'Inventario Esperado',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/settings/expected-inventory'
            }
        ]
    }
];

// Navigation for Store Admin users (single store access)
export const storeAdminNavigation: FuseNavigationItem[] = [
    {
        id: 'store-dashboard',
        title: 'Mi Tienda',
        type: 'basic',
        icon: 'heroicons_outline:building-storefront',
        link: '/store-dashboard'
    },
    {
        id: 'operations',
        title: 'Operaciones',
        type: 'collapsable',
        icon: 'heroicons_outline:arrows-right-left',
        children: [
            {
                id: 'initial-stock',
                title: 'Carga Inicial',
                type: 'basic',
                icon: 'heroicons_outline:inbox-arrow-down',
                link: '/operations/initial-stock'
            },
            {
                id: 'inventory-count',
                title: 'Conteo Fisico',
                type: 'basic',
                icon: 'heroicons_outline:calculator',
                link: '/operations/inventory-count'
            },
            {
                id: 'movements',
                title: 'Movimientos',
                type: 'basic',
                icon: 'heroicons_outline:arrow-path',
                link: '/operations/movements'
            }
        ]
    },
    {
        id: 'inventory',
        title: 'Inventario',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'balances',
                title: 'Saldos',
                type: 'basic',
                icon: 'heroicons_outline:scale',
                link: '/inventory/balances'
            }
        ]
    },
    {
        id: 'catalogs',
        title: 'Catalogos',
        type: 'collapsable',
        icon: 'heroicons_outline:folder',
        children: [
            {
                id: 'basket-types',
                title: 'Tipos de Cestas',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/catalogs/basket-types'
            }
        ]
    }
];

// Default navigation (used as fallback, same as superAdmin for now)
export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard'
    },
    {
        id: 'catalogs',
        title: 'Catalogos',
        type: 'collapsable',
        icon: 'heroicons_outline:folder',
        children: [
            {
                id: 'basket-types',
                title: 'Tipos de Cestas',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/catalogs/basket-types'
            },
            {
                id: 'locations',
                title: 'Ubicaciones',
                type: 'basic',
                icon: 'heroicons_outline:map-pin',
                link: '/catalogs/locations'
            },
            {
                id: 'vehicles',
                title: 'Vehiculos',
                type: 'basic',
                icon: 'heroicons_outline:truck',
                link: '/catalogs/vehicles'
            },
            {
                id: 'stores',
                title: 'Tiendas',
                type: 'basic',
                icon: 'heroicons_outline:building-storefront',
                link: '/catalogs/stores'
            },
            {
                id: 'forklifts',
                title: 'Montacargas',
                type: 'basic',
                icon: 'heroicons_outline:cube',
                link: '/catalogs/forklifts'
            },
            {
                id: 'forklift-operators',
                title: 'Operadores de Montacargas',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/catalogs/forklift-operators'
            },
            {
                id: 'pallet-jacks',
                title: 'Transpaletas',
                type: 'basic',
                icon: 'heroicons_outline:arrows-right-left',
                link: '/catalogs/pallet-jacks'
            },
            {
                id: 'repair-events',
                title: 'Reparaciones',
                type: 'basic',
                icon: 'heroicons_outline:wrench-screwdriver',
                link: '/catalogs/repair-events'
            },
            {
                id: 'repair-companies',
                title: 'Empresas de Reparacion',
                type: 'basic',
                icon: 'heroicons_outline:building-office',
                link: '/catalogs/repair-companies'
            }
        ]
    },
    {
        id: 'operations',
        title: 'Operaciones',
        type: 'collapsable',
        icon: 'heroicons_outline:arrows-right-left',
        children: [
            {
                id: 'movements',
                title: 'Movimientos',
                type: 'basic',
                icon: 'heroicons_outline:arrow-path',
                link: '/operations/movements'
            },
            {
                id: 'initial-stock',
                title: 'Carga Inicial',
                type: 'basic',
                icon: 'heroicons_outline:inbox-arrow-down',
                link: '/operations/initial-stock'
            },
            {
                id: 'inventory-count',
                title: 'Conteo Fisico',
                type: 'basic',
                icon: 'heroicons_outline:calculator',
                link: '/operations/inventory-count'
            },
            {
                id: 'trip-log',
                title: 'Registro de Viaje',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/operations/trip-log'
            },
            {
                id: 'routes',
                title: 'Rutas',
                type: 'basic',
                icon: 'heroicons_outline:map',
                link: '/operations/routes'
            }
        ]
    },
    {
        id: 'inventory',
        title: 'Inventario',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'balances',
                title: 'Saldos',
                type: 'basic',
                icon: 'heroicons_outline:scale',
                link: '/inventory/balances'
            },
            {
                id: 'snapshots',
                title: 'Historico',
                type: 'basic',
                icon: 'heroicons_outline:clock',
                link: '/inventory/snapshots'
            }
        ]
    },
    {
        id: 'incidents',
        title: 'Incidencias',
        type: 'collapsable',
        icon: 'heroicons_outline:exclamation-triangle',
        children: [
            {
                id: 'incidents-list',
                title: 'Incidencias',
                type: 'basic',
                icon: 'heroicons_outline:flag',
                link: '/incidents'
            },
            {
                id: 'damaged',
                title: 'Cestas Danadas',
                type: 'basic',
                icon: 'heroicons_outline:x-circle',
                link: '/incidents/damaged'
            },
            {
                id: 'recycling',
                title: 'Reciclaje',
                type: 'basic',
                icon: 'heroicons_outline:arrow-path-rounded-square',
                link: '/incidents/recycling'
            },
            {
                id: 'police-assistance',
                title: 'Apoyo Policial',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/incidents/police-assistance'
            },
            {
                id: 'road-assistance',
                title: 'Auxilio Vial',
                type: 'basic',
                icon: 'heroicons_outline:truck',
                link: '/incidents/road-assistance'
            }
        ]
    },
    {
        id: 'settings',
        title: 'Configuracion',
        type: 'collapsable',
        icon: 'heroicons_outline:cog-6-tooth',
        children: [
            {
                id: 'users',
                title: 'Usuarios',
                type: 'basic',
                icon: 'heroicons_outline:users',
                link: '/settings/users'
            },
            {
                id: 'roles',
                title: 'Roles',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/settings/roles'
            },
            {
                id: 'expected-inventory',
                title: 'Inventario Esperado',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/settings/expected-inventory'
            }
        ]
    }
];

export const compactNavigation: FuseNavigationItem[] = defaultNavigation;
export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
